import { getFetchWrapper } from "@syf-api-library/core";
import { paymentMethodsUrl } from "../endpoints.js";
const queryFnFactory = (config, keyProps, headers = {}) => {
  const fetchWrapper = getFetchWrapper(config);
  return () => {
    const params = new URLSearchParams({
      "cipher.accountId": keyProps.accountId,
      bankChannel: "DIGITAL"
    });
    if (keyProps.accountIdType) {
      params.set("accountIdType", keyProps.accountIdType);
    }
    return fetchWrapper(`${paymentMethodsUrl}?${params}`, {
      method: "GET",
      headers
    });
  };
};
export {
  queryFnFactory as default
};
//# sourceMappingURL=query.js.map
